import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_order_approvers_and_sales_reps: { message: "idle" },
};

export const retrieve_tenant_order_approvers_and_sales_reps_Slice = createSlice({
 name: "retrieve_tenant_order_approvers_and_sales_reps",
 initialState,
 reducers: {
  success_retrieve_tenant_order_approvers_and_sales_reps: (state, action) => {
   state.retrieve_tenant_order_approvers_and_sales_reps = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_order_approvers_and_sales_reps: (state, action) => {
   state.retrieve_tenant_order_approvers_and_sales_reps = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_order_approvers_and_sales_reps: (state) => {
   state.retrieve_tenant_order_approvers_and_sales_reps = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_order_approvers_and_sales_reps: (state) => {
   state.retrieve_tenant_order_approvers_and_sales_reps = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_order_approvers_and_sales_reps, fail_retrieve_tenant_order_approvers_and_sales_reps, reset_retrieve_tenant_order_approvers_and_sales_reps, loading_retrieve_tenant_order_approvers_and_sales_reps } = retrieve_tenant_order_approvers_and_sales_reps_Slice.actions;

export default retrieve_tenant_order_approvers_and_sales_reps_Slice.reducer;